import axios from 'axios';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

function ShashiUnpluggedGuest(props) {

  const { token: tkn } = useParams();
  const token = tkn || props.token;

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_RESERVATION}/v1/magic-link-session/start-session`, { 'app-token': token }).then((res) => {
      if (res.data?.result?.data?.storeUrl) {
        window.open(res.data?.result?.data?.storeUrl, '_self');
      }
    }).catch((err) => {
      alert(err?.response?.data?.result?.message || 'Something went wrong');
    });
  }, []);

  return (
    <div>
      {/* {token} */}
    </div>
  );
}

export default ShashiUnpluggedGuest;
